import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useUpsell } from './UpsellContext';
export const StickyCTA: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const {
    openUpsell
  } = useUpsell();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-156">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 w-full bg-white border-t-2 border-cream-dark px-4 py-3 shadow-[0_-10px_30px_rgba(36,17,74,0.12)] z-50 md:hidden" data-id="element-157">
          <div className="max-w-md mx-auto flex items-center gap-3" data-id="element-158">
            <div className="flex-shrink-0 leading-tight" data-id="element-159">
              <p className="text-[10px] text-gray-400 font-bold line-through" data-id="element-160">
                $39.990
              </p>
              <p className="text-lg font-rounded font-bold text-violet leading-none" data-id="element-161">
                $9.990
              </p>
            </div>
            <button type="button" onClick={openUpsell} className="flex-grow text-center cta-gradient text-violet font-rounded font-bold uppercase rounded-xl shadow-md border-b-[3px] border-[#c89020] transition-all duration-200 active:scale-[0.98] py-3 px-4 text-sm" data-id="element-162">
              Quiero mi biblioteca
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};